export const replicationLinks = [
  {
    url: '/replication-server.html',
    label: 'RxServer',
    iconUrl: '/files/logo/logo.svg',
  },
  {
    url: '/replication-graphql.html',
    label: 'GraphQL',
    iconUrl: '/files/icons/graphql.svg',
  },
  {
    url: '/replication-firestore.html',
    label: 'Firebase',
    iconUrl: '/files/icons/firebase.svg',
  },
  {
    url: '/replication-supabase.html',
    label: 'Supabase',
    iconUrl: '/files/icons/supabase.svg',
  },
  {
    url: '/replication-mongodb.html',
    label: 'MongoDB',
    iconUrl: '/files/icons/mongodb-icon.svg',
  },
  {
    url: '/replication-nats.html',
    label: 'NATS',
    iconUrl: '/files/icons/nats.svg',
  },
  {
    url: '/replication-http.html',
    label: 'HTTP',
    iconUrl: '/files/icons/http.svg',
  },
  {
    url: '/replication-couchdb.html',
    label: 'CouchDB',
    iconUrl: '/files/icons/couchdb.svg',
  },
  {
    url: '/replication-webrtc.html',
    label: 'WebRTC (P2P)',
    iconUrl: '/files/icons/webrtc.svg',
  },
  {
    url: '/replication-appwrite.html',
    label: 'appwrite',
    iconUrl: '/files/icons/appwrite-small.svg',
  },
  {
    url: '/replication-google-drive.html',
    label: 'Google Drive',
    iconUrl: '/files/icons/google-drive.svg',
  },
  {
    url: '/replication-microsoft-onedrive.html',
    label: 'Microsoft OneDrive',
    iconUrl: '/files/icons/onedrive.svg',
  },
];
